import ApiCommerce from '@/core/apis/ApiCommerce';
import { IResposta } from '@/core/models/IResposta';
import { IServicoBase } from '@/core/models/IServicoBase';
import { IRepostaConsulta } from '@/core/models/IRepostaConsulta';
import { IDTOCandidato } from '@/models/DTO/IDTOCandidato';
import { ICandidato } from '@/models/Entidades/ICandidato';
import { IParametrosBuscaRapida } from '@/core/models/Consulta/IParametrosBuscaRapida';
import { IItemBuscaRapida } from '@/core/models/Consulta/IItemBuscaRapida';
import { ICandidatoParametrosConsulta } from '@/models/ParametrosRequisicao/Consulta/ICandidatoParametrosConsulta';
import { IRetornoRelatorio } from '@/core/models/IRetornoRelatorio';
/**
 * Serviço de Candidato
 */

class ServicoCandidato implements IServicoBase<ICandidato> {
  endPoint = 'candidatos';

  apiCommerce = new ApiCommerce();

  public async incluir(cliente: ICandidato): Promise<IResposta> {
    const result: any = await this.apiCommerce.post(`${this.endPoint}`, cliente);
    return result.data;
  }

  public async atualizar(cliente: ICandidato): Promise<IResposta> {
    const result: any = await this.apiCommerce.put(`${this.endPoint}/${cliente.codigo}`, cliente);
    return result.data;
  }

  public async obter(codigo: number): Promise<ICandidato> {
    const result: any = await this.apiCommerce.get(`${this.endPoint}/${codigo}`);
    return result.data;
  }

  public async imprimirFicha(codigo: number): Promise<IRetornoRelatorio> {
    const result: any = await this.apiCommerce.get(`${this.endPoint}/${codigo}/relatorio/ficha`);
    return result.data;
  }

  public async obterCandidatos(parametrosConsulta: ICandidatoParametrosConsulta): Promise<IRepostaConsulta<IDTOCandidato>> {
    let parametrosAdicionais = '';

    if (parametrosConsulta.valorPesquisa !== undefined) {
      parametrosAdicionais += `?ValorPesquisa=${parametrosConsulta.valorPesquisa}`;
    }

    if (parametrosConsulta.status !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `Status=${parametrosConsulta.status}`;
    }

    if (parametrosConsulta.setor !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `Setor=${parametrosConsulta.setor}`;
    }

    if (parametrosConsulta.grauInstrucao !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `GrauInstrucao=${parametrosConsulta.grauInstrucao}`;
    }

    if (parametrosConsulta.genero !== undefined) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `Genero=${parametrosConsulta.genero}`;
    }

    if (parametrosConsulta.numeroPagina !== undefined && parametrosConsulta.numeroPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `NumeroPagina=${parametrosConsulta.numeroPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosPagina !== undefined && parametrosConsulta.qtdeRegistrosPagina > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosPagina=${parametrosConsulta.qtdeRegistrosPagina}`;
    }
    if (parametrosConsulta.qtdeRegistrosTotal !== undefined && parametrosConsulta.qtdeRegistrosTotal > 0) {
      parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
      parametrosAdicionais += `QtdeRegistrosTotal=${parametrosConsulta.qtdeRegistrosTotal}`;
    }
    if (parametrosConsulta.ordenacao !== undefined) {
      parametrosConsulta.ordenacao.forEach((item) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Ordenacao=${item}`;
      });
    }
    if (parametrosConsulta.codigos !== undefined) {
      parametrosConsulta.codigos.forEach((codigo) => {
        parametrosAdicionais += (parametrosAdicionais !== '' ? '&' : '?');
        parametrosAdicionais += `Codigos=${codigo}`;
      });
    }
    const result: any = await this.apiCommerce.get(`${this.endPoint}${parametrosAdicionais}`);
    return result.data;
  }

  public async buscaRapida(parametrosConsultaRapida: IParametrosBuscaRapida): Promise<IItemBuscaRapida[]> {
    const parametros = this.apiCommerce.obterParametrosBuscaRapida(parametrosConsultaRapida);
    const result: any = await this.apiCommerce.get(`${this.endPoint}/busca-rapida${parametros}`);
    return result.data;
  }

  public async deletar(codigo: number): Promise<IResposta> {
    const result: any = await this.apiCommerce.delete(`${this.endPoint}/${codigo}`);
    return result.data;
  }
}

export default ServicoCandidato;
